
class MultiSelectComponents extends HTMLElement {
  constructor() {
    super();

    this.multiLabel = this.querySelector('.js-multi-select');
    this.multiOptions = this.querySelector('.js-multi-options');
    this.selectionList = this.querySelectorAll('input[class="multi__select-input"]');
    this.shownListWrap = this.querySelector('.js-selected-list-shown .selected-list--wrap');
    this.shownList = this.querySelector('.js-selected-list-shown .selected-list--visible');
  }

  connectedCallback() {
    this.multiLabel.addEventListener('click', () => this.toggleMultiOptions());

    this.arrayOfSelection = [];
    this.shownSelectionCount = 1;
    this.selectionHiddenElement = document.createElement('span');
    this.selectionHiddenElement.classList.add('selected-count--hidden');
    this.onSelectChange();

    window.addEventListener('keydown', (event) => (!this.contains(event.target) && this.multiOptions.getAttribute('aria-hidden') === 'false') && this.toggleMultiOptions());
    window.addEventListener('mousedown', (event) => (!this.contains(event.target) && this.multiOptions.getAttribute('aria-hidden') === 'false') && this.toggleMultiOptions());
  }

  toggleMultiOptions() {
    this.multiOptions.setAttribute('aria-hidden', (this.multiOptions.getAttribute('aria-hidden') === 'false').toString());
  }

  onSelectChange() {
    this.selectionList.forEach((input) => input.addEventListener('change', () => {
      this.selectedList = this.querySelector('.js-selected-list');
      this.selectedListShown = this.querySelector('.js-selected-list-shown .selected-list--visible');

      input.checked ? this.arrayOfSelection.push(input.value) : this.arrayOfSelection.splice(this.arrayOfSelection.indexOf(input.value), 1);
      this.querySelector('.js-multi-select input[type="text"]').setAttribute('value', this.arrayOfSelection.join(', '));
      this.querySelector('.js-multi-select input[type="text"]').value = this.arrayOfSelection.join(', ');
      this.selectedList.textContent = this.arrayOfSelection.join(', ');

      this.arrayOfSelection = this.arrayOfSelection;
      this.arrayOfSelectionShown = Array.from(this.arrayOfSelection);
      if(this.selectedList.offsetWidth <= this.shownListWrap.offsetWidth) {
        this.shownList.textContent = this.arrayOfSelection.join(', ');
      } else {
        this.arrayOfHiddenSelection = Array.from(this.arrayOfSelection);
        this.arrayOfHiddenSelection.splice(0, this.shownSelectionCount);
        this.selectionHiddenElement.textContent = `+${this.arrayOfHiddenSelection.length} more...`;
        this.arrayOfSelectionShown.splice(this.shownSelectionCount, this.arrayOfHiddenSelection.length);
        this.shownList.textContent = this.arrayOfSelectionShown.join(', ');
        this.shownList.appendChild(this.selectionHiddenElement);
      }
    }));
  }
}

customElements.define('multi-select', MultiSelectComponents);